var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"homemainbigbox"},[_c('el-row',{staticClass:"bannerbox"},[_c('banner')],1),_c('el-row',{staticClass:"main"},[_c('mainOne'),_c('mainTwo'),_c('mainThree'),_c('mainFour'),_c('foot')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }